import api from '../../plugins/api';

// GET /api/crm/vin-blacklist — список с поиском по VIN и страницами. Только админ.
const getVinBlacklist = (params) => {
  return api.get('/api/crm/vin-blacklist', params);
};

export default getVinBlacklist;
